import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

export const filters = {
  actions,
  getters,
  mutations,
  state,
  name: 'filters'
};
